import { declOfNum } from '@/utils'

/**
 * Пробный период на карточке интеграции в маркетплейсе.
 * Чтобы включить его у другой интеграции, добавьте объект сюда:
 * `moduleKey` — ключ из `config.marketplaceModulesIds`.
 * Кнопка сама не появится, если вместо покупки интеграция просит оставить заявку.
 */
export interface MarketplaceTrialOffer {
    moduleKey: string
    productName: string
    title: string
    description: string
    days: number
    highlightNote: string
    readyText: string
}

export const marketplaceTrialOffers: MarketplaceTrialOffer[] = [
    {
        moduleKey: 'hotWindows',
        productName: 'Горячие окна',
        title: 'Попробуйте горячие окна\nв своём проекте',
        description:
            'Находите свободное время, выбирайте услуги и предлагайте запись подходящим клиентам.',
        days: 5,
        highlightNote: 'Отсчёт начнётся, когда вы активируете пробный период.',
        readyText: 'Начните, когда будете готовы изучить модуль.',
    },
    {
        moduleKey: 'businessPulseReport',
        productName: 'Отчёт 2.0',
        title: 'Попробуйте отчёт 2.0\nв своём проекте',
        description:
            'Смотрите выручку, клиентов и записи за выбранный период и сравнивайте с прошлым.',
        days: 1,
        highlightNote: 'Отсчёт начнётся, когда вы активируете пробный период.',
        readyText: 'Начните, когда будете готовы изучить отчёт.',
    },
    {
        moduleKey: 'opz2',
        productName: 'ОПЗ 2.0',
        title: 'Попробуйте ОПЗ 2.0\nв своём проекте',
        description:
            'Смотрите повторные записи, кросс-продажи и результат работы администраторов.',
        days: 5,
        highlightNote: 'Отсчёт начнётся, когда вы активируете пробный период.',
        readyText: 'Начните, когда будете готовы изучить отчёт.',
    },
]

export function trialPeriodLabel(days: number): string {
    return `${days} ${declOfNum(days, ['день', 'дня', 'дней'])}`
}

export function trialFreeCaption(days: number): string {
    return `${declOfNum(days, ['день', 'дня', 'дней'])} бесплатно`
}

export function trialModulePath(moduleKey: string, projectId: string): string | null {
    if (moduleKey === 'hotWindows') return `/project/${projectId}/GCB2/hotWindows`
    if (moduleKey === 'businessPulseReport') return `/project/${projectId}/GCB2/businessPulseReport`
    if (moduleKey === 'opz2') return `/project/${projectId}/GCB2/sameDayRec`
    return null
}

export function findTrialOffer(moduleKey: string | undefined | null): MarketplaceTrialOffer | null {
    if (!moduleKey) return null
    return marketplaceTrialOffers.find(offer => offer.moduleKey === moduleKey) ?? null
}

export function findTrialOfferByIntegrationId(
    integrationId: string | number | undefined | null,
    moduleIds: Record<string, string>,
): MarketplaceTrialOffer | null {
    if (integrationId == null || integrationId === '') return null
    const id = String(integrationId)
    return (
        marketplaceTrialOffers.find(offer => String(moduleIds[offer.moduleKey] || '') === id) ?? null
    )
}
